export default function Tags({ tags }) {
  return <span>#{tags},</span>;
}
